import { MIOObject } from "./MIOObject";

export class MIOError extends MIOObject
{
    errorCode = 0;
}